import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { PageDataService } from 'src/app/services/page-data.service';

@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {
    data: any = {}
    isMobile: boolean = false;
    isHome: boolean = true;

    rootPath: string = window.location.href.slice(0, -1)

    constructor(
        private breakpointObserver: BreakpointObserver,
        public pageDataService: PageDataService
    ) {
        breakpointObserver.observe([
            Breakpoints.HandsetLandscape,
            Breakpoints.HandsetPortrait
        ]).subscribe(result => {
            if (result.matches) {
                this.isMobile = true;
            }
            else {
                this.isMobile = false;
            }
        });

    }

    ngOnInit(): void {
        this.data = {
            slides: [
                {
                    id: 'MovieSphere',
                    tag: 'Free Live TV',
                    logo: 'assets/img/home/moviesphere-large-logo.png',
                    logoMobile: 'assets/img/home/moviesphere-large-logo.png',
                    description: 'MovieSphere is the place to find blockbuster hits to<br>indie favorites and everything in between.',

                    bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Fmovie%20sphere%2FMOVIESPHERE-Q2-2026-Promo-Video-v2.jpg?alt=media&token=9470154d-c2ad-4d52-a465-25159add8c38',
                    bgMobile: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Fmovie%20sphere%2FMOVIESPHERE-Promo-Video-Q2-2026-Mobile-v2.jpg?alt=media&token=2e870f7b-5c7f-4e3c-aab6-a8a167fdf544',
                    tt: '',
                    video: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Fmovie%20sphere%2FMOVIESPHERE-Q2-2026-Promo-Video.mp4?alt=media&token=c0db0eb1-1d88-4fa7-9d18-c32925326965',
                    videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Fmovie%20sphere%2FMOVIESPHERE-Promo-Video-Q2-2026-Mobile.mp4?alt=media&token=61b20a58-49b6-49ca-a416-acc1dc5b086b',
                    sizzleVideoLabel: 'Channel Preview',
                    isSlideshow: false,
                    videoLabels: [
                        {
                            title: "The Hunger Games:<br>The Ballad Of Songbirds & Snakes ",
                            start: 5,
                            end: 10,
                        },
                        {
                            title: "War On Everyone",
                            start: 10,
                            end: 14,
                        },
                        {
                            title: "Amber Alert",
                            start: 15,
                            end: 16.3,
                        },
                        {
                            title: "Molly's Game",
                            start: 16.4,
                            end: 17.1,
                        },
                        {
                            title: "Are You There God?<br>It's Me, Margaret",
                            start: 17.2,
                            end: 21.1,
                        },
                        {
                            title: "Amber Light",
                            start: 21 / 2,
                            end: 22,
                        },
                        {
                            title: "War On Everyone",
                            start: 22 / 1,
                            end: 24,
                        },
                        {
                            title: "The Hunger Games:<br>The Ballad Of Songbirds & Snakes",
                            start: 24.1,
                            end: 25.3,
                        },

                    ],
                    button: {
                        colorBG: '#ff5163',
                        color: "#fff",
                        label: 'TV Schedule',
                        url: '/movie-sphere',
                    },
                    thumb: 'assets/img/home/logos/moviesphere-logo-small-desktop.png',
                    thumbMobile: 'assets/img/home/moviesphere-square-thumb.jpg',
                },
                {
                    id: '50CentAction',
                    tag: 'Free Live TV',
                    logo: 'assets/img/home/50centaction/50centaction-logo-desktop.png',
                    logoMobile: 'assets/img/home/50centaction/50centaction-logo-desktop.png',
                    description: '50 Cent Action brings you high-octane movies and series, curated by 50 Cent himself, for the ultimate thrill ride.',
                    bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2F50cent-action%2F50-CENT-ACTION-Q2-2026-Promo-Video-v2.jpg?alt=media&token=33c85e35-b859-4312-8bc6-ce4a855ce4d2',
                    bgMobile: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2F50cent-action%2F50-CENT-ACTION-Q2-2026-Promo-Video-Mobile-v2.jpg?alt=media&token=d5bd303e-2871-42b8-a79c-9c4395ddbc8f',
                    tt: '',
                    video: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Fmovie%20sphere%2F50-CENT-ACTION-Q2-2026-Promo-Video.mp4?alt=media&token=2327c769-28d5-4a7f-b107-4f61ee240c32',
                    videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Fmovie%20sphere%2F50-CENT-ACTION-Q2-2026-Promo-Video-Mobile.mp4?alt=media&token=203a954d-beb7-4ecb-b328-2dd95b1ae1d3',
                    sizzleVideoLabel: 'Channel Preview',
                    // sizzleVideoLabel: '',
                    isSlideshow: false,
                    button: {
                        colorBG: '#FE0002',
                        color: '#fff',
                        label: 'TV Schedule',
                        url: '/50centaction',
                    },
                    thumb: 'assets/img/home/logos/50centaction-logo-small-desktop.png',
                    thumbMobile: 'assets/img/home/50centaction/50centaction-square-mobile.jpg',
                    videoLabels: [
                        {
                            title: "The Gentlemen",
                            start: 1.02,
                            end: 1.20,
                        },
                        {
                            title: "Dredd",
                            start: 1.21,
                            end: 2.17,
                        },
                        {
                            title: "Sicario",
                            start: 2.18,
                            end: 3.20,
                        },
                        {
                            title: "Midway",
                            start: 3.21,
                            end: 5.05,
                        },
                        {
                            title: "The Commuter",
                            start: 5.06,
                            end: 8.06,
                        },
                        {
                            title: "Sicario",
                            start: 8.07,
                            end: 10.08,
                        },
                        {
                            title: "The Gentlemen",
                            start: 10.09,
                            end: 11.08,
                        },
                        {
                            title: "Dredd",
                            start: 11.09,
                            end: 12.18,
                        },
                        {
                            title: "Midway",
                            start: 12.19,
                            end: 14.17,
                        },
                        {
                            title: "The Gentlemen",
                            start: 14.18,
                            end: 16.13,
                        },
                        {
                            title: "Dredd",
                            start: 16.14,
                            end: 17.05,
                        },
                        {
                            title: "Midway",
                            start: 17.06,
                            end: 18.01,
                        },
                        {
                            title: "The Commuter",
                            start: 18.02,
                            end: 20.18,
                        },
                        {
                            title: "Dredd",
                            start: 20.19,
                            end: 22.10,
                        },
                        {
                            title: "The Gentlemen",
                            start: 22.11,
                            end: 23.08,
                        },
                        {
                            title: "Dredd",
                            start: 23.09,
                            end: 24.18,
                        },
                    ]
                },
                {
                    id: 'hersphere',
                    tag: 'Free Live TV',
                    logo: 'assets/img/home/hersphere-large-logo.png',
                    logoMobile: 'assets/img/home/hersphere-large-logo.png',
                    description: 'HerSphere brings together the female-driven stories you love from Lionsgate’s premium library and beyond.',
                    // bg: 'assets/img/home/homepage-hersphere.jpg',
                    // bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Fhersphere-q4-2024%2Fhersphere-homepage-video-desktop-winter2024.jpg?alt=media&token=adff3a25-892b-4f69-bc14-342311266d34',
                    bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Fhersphere%2FHERSPHERE-Q2-2026-Promo-Video.jpg?alt=media&token=16f71f61-4419-4acd-9ea9-4f613bad472e',
                    // bgMobile: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Fhersphere-q4-2024%2Fhersphere-homepage-video-mobile-winter2024.jpg?alt=media&token=525adbf2-f468-41eb-bada-6046e4a1599f',
                    bgMobile: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Fhersphere%2FHERSPHERE-Promo-Video-Q2-Mobile.jpg?alt=media&token=436aa977-3b7c-44ae-b8a1-10002718c827',
                    tt: '',
                    // video: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Fhersphere-q4-2024%2Fhersphere-homepage-video-desktop-winter2024.mp4?alt=media&token=0f3826e1-7700-44ae-9186-7086e68890ce',
                    video: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Fhersphere%2FHERSPHERE-Q2-2026-Promo-Video.mp4?alt=media&token=605c5307-b743-4e15-9bb7-c60a2235dfc5',
                    // videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Fhersphere-q4-2024%2Fhersphere-homepage-video-mobile-winter2024-v2.mp4?alt=media&token=f721a3c1-1ad3-4d53-af07-f0309dbc9a47',
                    videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Fhersphere%2FHERSPHERE-Promo-Video-Q2-Mobile.mp4?alt=media&token=883ce96f-4578-4800-aa7c-3a9345e71e2f',
                    sizzleVideoLabel: 'Channel Preview',
                    isSlideshow: false,
                    button: {
                        colorBG: '#2efbac',
                        color: '#fff',
                        label: 'TV Schedule',
                        url: '/her-sphere',
                    },
                    thumb: 'assets/img/home/logos/hersphere-logo-small-desktop.png',
                    thumbMobile: 'assets/img/home/hersphere-square-thumb.jpg',
                    videoLabels: [
                        {
                            title: "Joy Ride",
                            start: 1.03,
                            end: 4.04,
                        },
                        {
                            title: "Rogue",
                            start: 4.05,
                            end: 5.13,
                        },
                        {
                            title: "Molly's Game",
                            start: 5.14,
                            end: 6.06,
                        },
                        {
                            title: "Minx",
                            start: 6.07,
                            end: 7.05,
                        },
                        {
                            title: "Minx",
                            start: 8.12,
                            end: 13.07,
                        },
                        {
                            title: "Joy Ride",
                            start: 13.08,
                            end: 14.02,
                        },
                        {
                            title: "Float",
                            start: 14.03,
                            end: 14.21,
                        },
                        {
                            title: "Rogue",
                            start: 14.22,
                            end: 16.16,
                        },
                        {
                            title: "Joy Ride",
                            start: 16.18,
                            end: 17.11,
                        },
                        {
                            title: "Rogue",
                            start: 17.12,
                            end: 18.06,
                        },
                        {
                            title: "Molly's Game",
                            start: 18.07,
                            end: 21.09,
                        },
                        {
                            title: "Joy Ride",
                            start: 21.10,
                            end: 22.01,
                        },
                        {
                            title: "Float",
                            start: 22.02,
                            end: 23.10,
                        },
                        {
                            title: "Joy Ride",
                            start: 23.11,
                            end: 24.02,
                        },
                        {
                            title: "Minx",
                            start: 24.03,
                            end: 26.08,
                        },
                        {
                            title: "Joy Ride",
                            start: 26.09,
                            end: 27.04,
                        },
                    ]
                },
                {
                    id: 'ebonytv',
                    tag: 'Free Live TV',
                    logo: 'assets/img/home/ebonytv-large-logo-v2.png',
                    logoMobile: 'assets/img/home/ebonytv-large-logo-v2.png',
                    description: 'EBONY TV features award-winning films, engaging comedies, and groundbreaking series that celebrate the global richness of Black culture.',
                    // bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Febony-tv-q4%2Febonytv-homepage-video-desktop-winter-2024.jpg?alt=media&token=30d57350-bf89-4f28-b3b4-7cb80be4af6d',
                    bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Febonytv%2FEBONYTV-Q2-2025-Promo-Video-v2.jpg?alt=media&token=20d9b284-5b1d-40d1-aea9-7546a4df3c7c',

                    // bgMobile: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Febony-tv-q4%2Febonytv-homepage-video-mobile-Q3-2024.jpg?alt=media&token=306f0247-67ee-45ab-a2dd-0add94c6c6eb',
                    bgMobile: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Febonytv%2FEBONYTV-Q2-2025-Promo-Video-Mobile-v2.jpg?alt=media&token=0c2638dd-f8dc-4fc6-9775-08b71a28fc26',
                    tt: '',
                    // video: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Febony-tv-q4%2Febonytv-homepage-video-desktop-winter-2024.mp4?alt=media&token=adc45230-b24b-411b-a11c-4940d32d40af',
                    video: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Febonytv%2FEBONYTV-Q2-2025-Promo-Video.mp4?alt=media&token=f3203e25-f01d-4640-bfb1-5ff460d78dc6',
                    // videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Febony-tv-q4%2Febonytv-homepage-video-mobile-Q3-2024-v2.mp4?alt=media&token=915904af-2547-47b3-8315-69700b3585a2',
                    videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Febonytv%2FEBONYTV-Q2-2025-Promo-Video-Mobile.mp4?alt=media&token=0c7d3be6-54eb-40a9-9982-9363c0a62b91',
                    sizzleVideoLabel: 'Channel Preview',
                    isSlideshow: false,
                    button: {
                        colorBG: '#e02b2e',
                        color: '#fff',
                        label: 'TV Schedule',
                        url: '/ebonytv',
                    },
                    thumb: 'assets/img/home/logos/ebonytv-logo-small-desktop.png',
                    thumbMobile: 'assets/img/home/ebonytv-square-thumb.jpg',
                },
                {
                    id: 'outersphere',
                    tag: 'Free Live TV',
                    logo: 'assets/img/home/outersphere-large-logo.png',
                    logoMobile: 'assets/img/home/outersphere-large-logo.png',
                    description: 'From superheroes to the supernatural, monsters to magicians, blockbusters to cult classics, OuterSphere has your sci-fi favorites.',
                    // bg: 'assets/img/home/homepage-ebonytv.jpg',
                    bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Foutersphere%2FOUTERSPHERE-Q4-2023-Promo-Video.jpg?alt=media&token=7e476617-ddfd-401e-95cd-43fb0d8b5756',
                    bgMobile: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Foutersphere%2FOUTERSPHERE-Q4-2023-Promo-Video-Mobile.jpg?alt=media&token=6e9be94f-121c-4862-b557-a5054a5a55f8',
                    tt: '',
                    video: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Foutersphere%2FOUTERSPHERE-Q4-2023-Promo-Video.mp4?alt=media&token=b0ba3f0e-a5e3-4bd5-85cf-c50aa2026d72',
                    videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Foutersphere%2FOUTERSPHERE-Q4-2023-Promo-Video-Mobile.mp4?alt=media&token=0190e2f8-d46a-449b-8212-1f276a2bb69b',
                    sizzleVideoLabel: 'Channel Preview',
                    isSlideshow: false,
                    button: {
                        colorBG: '#95e42c',
                        color: '#fff',
                        label: 'TV Schedule',
                        url: '/outer-sphere',
                    },
                    thumb: 'assets/img/home/logos/outersphere-logo-small-desktop.png',
                    thumbMobile: 'assets/img/home/outersphere-square-thumb.jpg',
                },
                {
                    id: 'lawless',
                    tag: '',
                    logo: 'assets/img/home/lawless-large-logo-temp-v2.png',
                    logoMobile: 'assets/img/lawless/lawless-homepage-promo-logo-mobile_480.png',
                    isLargeLogo: false,
                    largeLogo: 'assets/img/lawless/LAWLESS-large-logo-desktop-v2.png',
                    descriptionColor: '#c7b092',
                    description: 'Dive into the criminal underworld where justice is a<br> game, and the stakes are high.',
                    // bg: 'assets/img/home/homepage-ebonytv.jpg',
                    bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Flawless%2FLAWLESS-Q1-2025-Promo-Video.jpg?alt=media&token=75279a8d-785a-445a-ad05-9e3672b9215d',
                    bgMobile: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Flawless%2FLAWLESS-Q1-2025-Promo-Video-Mobile.jpg?alt=media&token=3891a6a4-1591-405d-86c8-455c727ba6cc',
                    tt: '',
                    video: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Flawless%2FLAWLESS-Q1-2025-Promo-Video.mp4?alt=media&token=f2799cbc-45fb-4e63-b215-5982bc609fab',
                    videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home_v2%2Flawless%2FLAWLESS-Q1-2025-Promo-Video-Mobile.mp4?alt=media&token=f0176199-c0fe-4732-aee1-5338bd339a1a',
                    sizzleVideoLabel: 'Channel Preview',
                    isSlideshow: false,
                    slideshowItems: [
                        {
                            img: "assets/img/home-v2/lawless/3-10-To-Yuma-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/lawless/mob/3-10-To-Yuma-Homepage-Promo-static-mobile.jpg",
                            label: "3:10 To Yuma",
                        },
                        {
                            img: "assets/img/home-v2/lawless/Cardinal-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/lawless/mob/Cardinal-TVShow-Homepage-Promo-static-mobile.jpg",
                            label: "Cardinal",
                        },
                        {
                            img: "assets/img/home-v2/lawless/Den-Of-Thieves-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/lawless/mob/Den-Of-Thieves-Homepage-Promo-static-mobile.jpg",
                            label: "Den Of Thieves",
                        },
                        {
                            img: "assets/img/home-v2/lawless/Lawless-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/lawless/mob/Lawless-Homepage-Promo-static-mobile.jpg",
                            label: "Lawless",
                        },
                        {
                            img: "assets/img/home-v2/lawless/Lincoln-Lawyer-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/lawless/mob/Lincoln-Lawyer-Homepage-Promo-static-mobile.jpg",
                            label: "Lincoln Lawyer",
                        },
                        {
                            img: "assets/img/home-v2/lawless/Massive-Talent-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/lawless/mob/Massive-Talent-Homepage-Promo-static-mobile.jpg",
                            label: "Massive Talent",
                        },
                        {
                            img: "assets/img/home-v2/lawless/Missing-TVShow-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/lawless/mob/Missing-TVShow-Homepage-Promo-static-mobile.jpg",
                            label: "Missing",
                        },
                        {
                            img: "assets/img/home-v2/lawless/Nash-Bridges-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/lawless/mob/Nash-Bridges-Homepage-Promo-static-mobile.jpg",
                            label: "Nash Bridges",
                        },
                        {
                            img: "assets/img/home-v2/lawless/Ransom-TVShow-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/lawless/mob/Ransom-TVShow-Homepage-Promo-static-mobile.jpg",
                            label: "Ransom",
                        },
                        {
                            img: "assets/img/home-v2/lawless/Redemption-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/lawless/mob/Redemption-Homepage-Promo-static-mobile.jpg",
                            label: "Redemption",
                        },
                        {
                            img: "assets/img/home-v2/lawless/Rogue-TVShow-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/lawless/mob/Rogue-TVShow-Homepage-Promo-static-mobile.jpg",
                            label: "Rogue",
                        },
                        {
                            img: "assets/img/home-v2/lawless/Rookie-Blue-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/lawless/mob/Rookie-Blue-Homepage-Promo-static-mobile.jpg",
                            label: "Rookie Blue",
                        },
                        {
                            img: "assets/img/home-v2/lawless/Swedish-Dick-TVShow-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/lawless/mob/Swedish-Dick-TVShow-Homepage-Promo-static-mobile.jpg",
                            label: "Swedish Dick",
                        },
                    ],
                    button: {
                        colorBG: '#895614',
                        color: '#fff',
                        label: 'TV Schedule',
                        url: '/lawless',
                    },
                    thumb: 'assets/img/home/logos/lawless-logo-small-desktop-v2.png',
                    thumbMobile: 'assets/img/home/lawless-square-thumb-mobile-v2.jpg',
                },
                {
                    id: 'extreme-jobs',
                    tag: '',
                    logo: 'assets/img/extreme-jobs/Extreme-Jobs-title.png',
                    logoMobile: 'assets/img/extreme-jobs/Extreme-Jobs-title.png',
                    isLargeLogo: false,
                    largeLogo: 'assets/img/extreme-jobs/Extreme-Jobs-large-logo.png',
                    descriptionColor: '#fff',
                    description: 'Experience thrilling gold rushes, high seas drama, masterful log home builds, dedicated animal care in the Scottish Highlands, and adrenaline-pumping storm chases. Every show is an adventure.',
                    // bg: 'assets/img/home/homepage-ebonytv.jpg',
                    bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q3%2FExtreme-Jobs-page-top-background-desktop-v2.jpg?alt=media&token=c0c17207-0042-4bae-a633-ea0aaaa0a2f7',
                    bgMobile: 'assets/img/extreme-jobs/Extreme-Jobs-page-background-top-mobile.jpg',
                    tt: '',
                    video: '',
                    videoMob: '',
                    sizzleVideoLabel: '',
                    isSlideshow: true,
                    slideshowItems: [
                        {
                            img: "assets/img/home-v2/extreme-jobs-slides/Wicked-Tuna-Outer-Banks-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/extreme-jobs-slides/mob/Wicked-Tuna-Outer-Banks-Homepage-Promo-static-mobile.jpg",
                            label: "Wicked Tuna Outer Banks",
                        },
                        {
                            img: "assets/img/home-v2/extreme-jobs-slides/Arctic-Vets-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/extreme-jobs-slides/mob/Arctic-Vets-Homepage-Promo-static-mobile.jpg",
                            label: "Arctic Vets",
                        },
                        {
                            img: "assets/img/home-v2/extreme-jobs-slides/Coldwater-Cowboys-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/extreme-jobs-slides/mob/Coldwater-Cowboys-Homepage-Promo-static-mobile.jpg",
                            label: "Coldwater Cowboys",
                        },
                        {
                            img: "assets/img/home-v2/extreme-jobs-slides/Mega-Builders-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/extreme-jobs-slides/mob/Mega-Builders-Homepage-Promo-static-mobile.jpg",
                            label: "Mega Builders",
                        },
                        {
                            img: "assets/img/home-v2/extreme-jobs-slides/The-Fast-And-The-Farmerish-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/extreme-jobs-slides/mob/The-Fast-And-The-Farmerish-Homepage-Promo-static-mobile.jpg",
                            label: "The Fast And The Farmerish",
                        },
                        {
                            img: "assets/img/home-v2/extreme-jobs-slides/The-Highland-Vet-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/extreme-jobs-slides/mob/The-Highland-Vet-Homepage-Promo-static-mobile.jpg",
                            label: "The Highland Vet",
                        },
                        {
                            img: "assets/img/home-v2/extreme-jobs-slides/The-Last-Overland-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/extreme-jobs-slides/mob/The-Last-Overland-Homepage-Promo-static-mobile.jpg",
                            label: "The Last Overland",
                        },
                        {
                            img: "assets/img/home-v2/extreme-jobs-slides/Timber-Kings-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/extreme-jobs-slides/mob/Timber-Kings-Homepage-Promo-static-mobile.jpg",
                            label: "Timber Kings",
                        },
                        {
                            img: "assets/img/home-v2/extreme-jobs-slides/Yukon-Gold-Homepage-Promo-static.jpg",
                            imgMob: "assets/img/home-v2/extreme-jobs-slides/mob/Yukon-Gold-Homepage-Promo-static-mobile.jpg",
                            label: "Yukon Gold",
                        },
                    ],
                    button: {
                        colorBG: '#678e8e',
                        color: '#fff',
                        label: 'TV Schedule',
                        url: '/extreme-jobs',
                    },
                    thumb: 'assets/img/home/logos/Extreme-Jobs-logo-small-desktop.png',
                    thumbMobile: 'assets/img/home/Extreme-Jobs-square-thumb-mobile.jpg',
                },

            ],
            showList: [
                {
                    thumb: 'assets/img/channel/designated-survivor/designated-surviovor-large-rectangle.jpg',
                    small: 'assets/img/channel/designated-survivor/designated-survivor-small-rectangle.jpg',
                    url: '/channel/designated-survivor',
                },
                {
                    thumb: 'assets/img/channel/new2/the-conners-large-rectangle.jpg',
                    small: 'assets/img/channel/new2/the-conners-small-rectangle.jpg',
                    url: '/channel/the-conners',
                },
                {
                    thumb: 'assets/img/channel/new2/nash-bridges-large-rectangle.jpg',
                    small: 'assets/img/channel/new2/nash-bridges-small-rectangle.jpg',
                    url: '/channel/nash-bridges',
                },
                // {
                //     thumb: 'assets/img/channel/new2/grace-and-frankie-large-rectangle.jpg',
                //     small: 'assets/img/channel/new2/grace-and-frankie-small-rectangle.jpg',
                //     url: '/channel/grace-and-frankie',
                // },
                {
                    thumb: 'assets/img/home/are-we-there-yet-large-rectangle.jpg',
                    small: 'assets/img/home/are-we-there-yet-small-rectangle.jpg',
                    url: '/channel/are-we-there-yet',
                },
                {
                    thumb: 'assets/img/home/anger-management-large-rectangle.jpg',
                    small: 'assets/img/home/anger-management-small-rectangle.jpg',
                    url: '/channel/anger-management',
                },
                {
                    thumb: 'assets/img/home/ghost-hunters-large-rectangle.jpg',
                    small: 'assets/img/home/ghost-hunters-small-rectangle.jpg',
                    url: '/channel/ghost-hunters',
                },
                {
                    thumb: 'assets/img/home/wanted-dead-or-alive-large-rectangle.jpg',
                    small: 'assets/img/home/wanted-dead-or-alive-small-rectangle.jpg',
                    url: '/channel/wanted-dead-or-alive',
                },
                {
                    thumb: 'assets/img/home/celebrity-wedding-large-rectangle.jpg',
                    small: 'assets/img/home/celebrity-wedding-small-rectangle.jpg',
                    url: '/channel/celebrity-name-game',
                },
                {
                    thumb: 'assets/img/home/caught-in-providence-large-rectangle.jpg',
                    small: 'assets/img/home/caught-in-providence-small-rectangle.jpg',
                    url: '/channel/caught-in-providence',
                },


                {
                    thumb: 'assets/img/home/nashville-large-rectangle.jpg',
                    small: 'assets/img/home/nashville-small-rectangle.jpg',
                    url: '/channel/nashville',
                },
                {
                    thumb: 'assets/img/home/love-thy-neighbor-large-rectangle.jpg',
                    small: 'assets/img/home/love-thy-neighbor-small-rectangle.jpg',
                    url: '/channel/love-thy-neighbor',
                },

                {
                    thumb: 'assets/img/home/wendy-williams-large-rectangle.jpg',
                    small: 'assets/img/home/wendy-williams-small-rectangle.jpg',
                    url: '/channel/wendy-williams',
                },
                {
                    thumb: 'assets/img/home/weeds-nurse-jackie-large-rectangle.jpg',
                    small: 'assets/img/home/weeds-nurse-jackie-small-rectangle.jpg',
                    url: '/channel/weeds-and-nurse-jackie',
                },
                {
                    thumb: 'assets/img/channel/heartland/heartland-large-rectangle.jpg',
                    small: 'assets/img/channel/heartland/heartland-small-rectangle.jpg',
                    url: '/channel/heartland',
                },
                {
                    thumb: 'assets/img/channel/wicked-tuna/wicked-tuna-large-rectangle.jpg',
                    small: 'assets/img/channel/wicked-tuna/wicked-tuna-small-rectangle.jpg',
                    url: '/channel/wicked-tuna',
                },



            ]
        }
    }



}
